import 'react-toastify/dist/ReactToastify.min.css';

import React from 'react';
import { useSelector } from 'react-redux';

import loadable from '@loadable/component';

import DealsTitleBanner from './Banner/DealsTitleBanners';
import ListerControls from './ListerControls/ListerControls';
import ListerFooter from './ListerFooter/ListerFooter';
import ListerHeader from './ListerHeader/ListerHeader';
import InfiniteScroll from './ProductList/InfiniteScroll';

const Slide = loadable(() => import('react-toastify'), {
	resolveComponent: (components) => components.Slide,
});
const ToastContainer = loadable(() => import('react-toastify'), {
	resolveComponent: (components) => components.ToastContainer,
});

export const SmallListerLayout = () => {
	const { isDealsPage } = useSelector((state) => state);

	const { ListerAddToBasketMobileButtonEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	window.dispatchEvent(new CustomEvent('loadable-component-loaded'));

	return (
		<div itemScope itemType="http://schema.org/ItemList">
			{isDealsPage && <DealsTitleBanner />}
			<ListerControls />

			<ListerHeader />

			<InfiniteScroll />

			<ListerFooter />

			{ListerAddToBasketMobileButtonEnabled && (
				<ToastContainer
					position="bottom-center"
					autoClose={5000}
					hideProgressBar
					newestOnTop={false}
					closeOnClick
					rtl={false}
					pauseOnFocusLoss
					draggable
					pauseOnHover
					closeButton={false}
					transition={Slide}
				/>
			)}
		</div>
	);
};

export default SmallListerLayout;
